import { CURRENCY_ISO, FORMATTING_LOCALE_CODE } from "./constants";
import { NumberFormatter as NF } from "./NumberFormatter";

interface CurrencyFormatOptions {
  prefix: string;
  suffix: string;
}

export const CURRENCY_FORMATTER: {
  [currency: string]: CurrencyFormatOptions;
} = {
  EUR: {
    prefix: "€ ",
    suffix: "",
  },
  USD: {
    prefix: "$ ",
    suffix: "",
  },
  GBP: {
    prefix: "£ ",
    suffix: "",
  },
  NOK: {
    prefix: "",
    suffix: " kr",
  },
  DKK: {
    prefix: "",
    suffix: " kr.",
  },
  SEK: {
    prefix: "",
    suffix: " kr",
  },
};

export function formatCurrency(
  amount: number | string,
  currencyCode: string = CURRENCY_ISO,
  locale: string = FORMATTING_LOCALE_CODE,
) {
  let amountStr;
  if (typeof amount === "number") {
    amountStr = NF.getPriceFormatter().format(amount);
  } else {
    amountStr = amount;
  }
  const currencyOptions = CURRENCY_FORMATTER[currencyCode];
  if (currencyOptions) {
    const { prefix, suffix } = currencyOptions;
    return prefix + amountStr + suffix;
  } else {
    return `${currencyCode} ${amountStr}`;
  }
}
